import React from "react";
import { Button, Layout, Tag, theme } from "antd";
import { useContext } from "react";
import { ConfigContext } from "../../components/Config";
import { Link } from "react-router";
import type { NavKey } from ".";
import { brandName } from "@mealmanager/legal-content";

const { Header } = Layout;

export type HeaderBarProps = {
    isDesktop: boolean;
    onNavigate?: (key: NavKey) => void;
    blogEnabled?: boolean;
    active?: NavKey;
};

const HeaderBar: React.FC<HeaderBarProps> = ({ isDesktop, onNavigate, blogEnabled = false, active }) => {
    const { state: config } = useContext(ConfigContext);
    const { token } = theme.useToken();
    return (
        <Header
            style={{
                height: isDesktop ? 72 : 64,
                background: token.Layout?.headerBg,
                padding: isDesktop ? "0 32px" : "0 18px",
                borderBottom: "1px solid var(--ant-color-border)",
                position: "sticky",
                top: 0,
                zIndex: 10,
            }}
        >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: "100%", maxWidth: 1180, margin: "0 auto" }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                        onClick={() => onNavigate?.("home")}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                onNavigate?.("home");
                            }
                        }}
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
                    >
                        <img alt="" src="/logo-dark.png" width={36} height={36} style={{ borderRadius: 12 }} />
                        <span className="display-heading" style={{ fontSize: isDesktop ? 28 : 22, lineHeight: 1, color: token.colorTextBase }}>{brandName}</span>
                        {config?.environment === "development" && <Tag color="success" style={{ marginLeft: 2 }}>dev</Tag>}
                        {config?.environment === "test" && <Tag color="warning" style={{ marginLeft: 2 }}>test</Tag>}
                    </div>
                </div>
                <span style={{ display: "inline-flex", alignItems: "center", gap: isDesktop ? 20 : 12 }}>
                    {blogEnabled && (
                        <Link
                            to="/blog"
                            aria-current={active === "blog" ? "page" : undefined}
                            style={{
                                color: active === "blog" ? token.colorPrimary : token.colorTextBase,
                                fontWeight: 600,
                                textDecoration: "none",
                            }}
                        >
                            Blog
                        </Link>
                    )}
                    <Button type="primary" onClick={() => window.location.href = config?.appBaseUrl + "/auth/sign-in"}>
                        Sign in
                    </Button>
                </span>
            </div>
        </Header>
    );
};

export default HeaderBar;
